import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import {
  updateRequest,
  updateSuccess,
  updateFailure,
  setObject,
  listRequest,
  listSuccess,
  listFailure,
  createRequest,
  createSuccess,
  createFailure,
} from './genericReducers'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  settingsUpdateRequest: ['params', 'callback'],
  settingsUpdateSuccess: ['data'],
  settingsUpdateFailure: ['error'],

  settingsStepUpdateRequest: ['params', 'callback'],
  settingsStepUpdateSuccess: ['data'],
  settingsStepUpdateFailure: ['error'],

  settingsTeamMemberUpdateRequest: ['params', 'callback'],
  settingsTeamMemberUpdateSuccess: ['data'],
  settingsTeamMemberUpdateFailure: ['error'],

  shopSettingUpdateRequest: ['params', 'callback'],
  shopSettingUpdateSuccess: ['data'],
  shopSettingUpdateFailure: ['error'],

  textSettingUpdateRequest: ['params', 'callback'],
  textSettingUpdateSuccess: ['data'],
  textSettingUpdateFailure: ['error'],

  settingsPlanUpgradeRequest: ['params', 'callback'],
  settingsPlanUpgradeSuccess: ['data'],
  settingsPlanUpgradeFailure: ['error'],

  settingsPlanCancelRequest: ['callback'],
  settingsPlanCancelSuccess: ['data'],
  settingsPlanCancelFailure: ['error'],

  settingsAddCalendlyTokenRequest: ['addCalendlyTokenParams', 'callback'],
  settingsAddCalendlyTokenSuccess: ['data'],
  settingsAddCalendlyTokenFailure: ['error'],

  settingsRemoveCalendlyTokenRequest: ['removeCalendlyTokenParams', 'callback'],
  settingsRemoveCalendlyTokenSuccess: ['data'],
  settingsRemoveCalendlyTokenFailure: ['error'],

  connectGoogleCalendar: ['code', 'callback'],
  disconnectGoogleCalendar: ['callback'],
  disconnectZoom: ['callback'],
  getStats: ['params', 'callback'],
  getAllCalendars: ['callback'],

  getDefaultLocale: ['params', 'callback'],

  usageListRequest: [],
  usageListSuccess: ['list'],
  usageListFailure: ['listError'],

  syncRequest: ['callback'],
  generateApiToken: ['callback'],
  generateZapierApiToken: ['callback'],
  checkAppBlock: ['callback'],
  sendCustomerioEvents: ['params'],
  setSettings: ['data'],
  checkCouponCode: ['params', 'callback'],

  orderTagsRequest: ['callback'],
  updateOrderTags: ['params', 'callback'],
  connectAppleCalendarRequest: ['params', 'callback'],
  disconnectAppleCalendarRequest: ['callback'],

  disconnectHubspot: ['callback'],
  verifyTextSettings: ['callback'],

  timezoneListRequest: [],
  timezoneListSuccess: ['timezoneList'],
  timezoneListFailure: ['timezoneListError'],

  deleteSenderSignature: ['callback'],
  getUsageData: ['params', 'callback'],

  connectKlaviyoRequest: ['params', 'callback'],
  disconnectKlaviyoRequest: ['callback'],
  updateTrial: ['params', 'callback'],
  me: ['callback'],

})

export const SettingsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  updateData: {},
  updateError: null,
  updateFetching: false,

  stepUpdateData: {},
  stepUpdateError: null,
  stepUpdateFetching: false,

  textUpdateData: {},
  textUpdateError: null,
  textUpdateFetching: false,

  addCalendlyTokenData: {},
  addCalendlyTokenError: null,
  addCalendlyTokenFetching: false,

  removeCalendlyTokenData: {},
  removeCalendlyTokenError: null,
  removeCalendlyTokenFetching: false,

  data: {},

  planError: null,
  planFetching: false,

  list: [],
  listFetching: null,
  listError: null,

  createData: {},
  createError: null,
  createFetching: false,
  createFetching: null,

  timezoneList: {},
  timezoneListFetching: null,
  timezoneListError: null,
})

/* ------------- Reducers ------------- */

export const reset = (state) => state.merge(INITIAL_STATE)

export const planRequest = (state) => {
  return state.merge({ planFetching: true, planError: null })
}

export const planSuccess = (state, { data }) => {
  return state.merge({ data, planFetching: false })
}

export const planFailure = (state, { planError }) => {
  return state.merge({ planError, planFetching: false })
}

export const stepUpdateRequest = (state, { stepUpdateParams }) => {
  return state.merge({
    stepUpdateParams,
    stepUpdateFetching: true,
    stepUpdateError: null,
  })
}

export const stepUpdateSuccess = (state, { stepUpdateData }) => {
  return state.merge({ stepUpdateData, stepUpdateFetching: false })
}

export const stepUpdateFailure = (state, { stepUpdateError }) => {
  return state.merge({ stepUpdateError, stepUpdateFetching: false })
}

export const textUpdateRequest = (state, { textUpdateParams }) => {
  return state.merge({
    textUpdateParams,
    textUpdateFetching: true,
    textUpdateError: null,
  })
}

export const textUpdateSuccess = (state, { textUpdateData }) => {
  return state.merge({ textUpdateData, textUpdateFetching: false })
}

export const textUpdateFailure = (state, { textUpdateError }) => {
  return state.merge({ textUpdateError, textUpdateFetching: false })
}

export const addCalendlyTokenRequest = (state, { addCalendlyTokenParams }) => {
  return state.merge({
    addCalendlyTokenParams,
    addCalendlyTokenFetching: true,
    addCalendlyTokenError: null,
  })
}

export const addCalendlyTokenSuccess = (state, { addCalendlyTokenData }) => {
  return state.merge({ addCalendlyTokenData, addCalendlyTokenFetching: false })
}

export const addCalendlyTokenFailure = (state, { addCalendlyTokenError }) => {
  return state.merge({
    addCalendlyTokenError,
    addCalendlyTokenFetching: false,
  })
}

export const removeCalendlyTokenRequest = (
  state,
  { removeCalendlyTokenParams }
) => {
  return state.merge({
    removeCalendlyTokenParams,
    removeCalendlyTokenFetching: true,
    removeCalendlyTokenError: null,
  })
}

export const removeCalendlyTokenSuccess = (
  state,
  { removeCalendlyTokenData }
) => {
  return state.merge({
    removeCalendlyTokenData,
    removeCalendlyTokenFetching: false,
  })
}

export const removeCalendlyTokenFailure = (
  state,
  { removeCalendlyTokenError }
) => {
  return state.merge({
    removeCalendlyTokenError,
    removeCalendlyTokenFetching: false,
  })
}
export const timezoneListRequest = (state) => {
  return state.merge({ timezoneListFetching: true, timezoneListError: null })
}

export const timezoneListSuccess = (state, { timezoneList }) => {
  return state.merge({ timezoneList, timezoneListFetching: false })
}
export const timezoneListFailure = (state, { timezoneListError }) => {
  return state.merge({ timezoneListError, timezoneListFetching: false })
}

/* ------------- Selectors ------------- */

export const SettingsSelectors = {
  settingsId: (state) => state.settings.data.id,
  settingsData: (state) => state.settings.data,
  isWeb: (state) => state.settings.isWeb || false,
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SETTINGS_UPDATE_REQUEST]: updateRequest,
  [Types.SETTINGS_UPDATE_SUCCESS]: updateSuccess,
  [Types.SETTINGS_UPDATE_FAILURE]: updateFailure,

  [Types.SETTINGS_STEP_UPDATE_REQUEST]: stepUpdateRequest,
  [Types.SETTINGS_STEP_UPDATE_SUCCESS]: stepUpdateSuccess,
  [Types.SETTINGS_STEP_UPDATE_FAILURE]: stepUpdateFailure,

  [Types.SHOP_SETTING_UPDATE_REQUEST]: stepUpdateRequest,
  [Types.SHOP_SETTING_UPDATE_SUCCESS]: stepUpdateSuccess,
  [Types.SHOP_SETTING_UPDATE_FAILURE]: stepUpdateFailure,

  [Types.TEXT_SETTING_UPDATE_REQUEST]: textUpdateRequest,
  [Types.TEXT_SETTING_UPDATE_SUCCESS]: textUpdateSuccess,
  [Types.TEXT_SETTING_UPDATE_FAILURE]: textUpdateFailure,

  [Types.SETTINGS_TEAM_MEMBER_UPDATE_REQUEST]: stepUpdateRequest,
  [Types.SETTINGS_TEAM_MEMBER_UPDATE_SUCCESS]: stepUpdateSuccess,
  [Types.SETTINGS_TEAM_MEMBER_UPDATE_FAILURE]: stepUpdateFailure,

  [Types.SETTINGS_PLAN_UPGRADE_REQUEST]: planRequest,
  [Types.SETTINGS_PLAN_UPGRADE_SUCCESS]: planSuccess,
  [Types.SETTINGS_PLAN_UPGRADE_FAILURE]: planFailure,

  [Types.SETTINGS_PLAN_CANCEL_REQUEST]: planRequest,
  [Types.SETTINGS_PLAN_CANCEL_SUCCESS]: planSuccess,
  [Types.SETTINGS_PLAN_CANCEL_FAILURE]: planFailure,

  [Types.SETTINGS_ADD_CALENDLY_TOKEN_REQUEST]: addCalendlyTokenRequest,
  [Types.SETTINGS_ADD_CALENDLY_TOKEN_SUCCESS]: addCalendlyTokenSuccess,
  [Types.SETTINGS_ADD_CALENDLY_TOKEN_FAILURE]: addCalendlyTokenFailure,

  [Types.SETTINGS_REMOVE_CALENDLY_TOKEN_REQUEST]: removeCalendlyTokenRequest,
  [Types.SETTINGS_REMOVE_CALENDLY_TOKEN_SUCCESS]: removeCalendlyTokenSuccess,
  [Types.SETTINGS_REMOVE_CALENDLY_TOKEN_FAILURE]: removeCalendlyTokenFailure,

  [Types.USAGE_LIST_REQUEST]: listRequest,
  [Types.USAGE_LIST_SUCCESS]: listSuccess,
  [Types.USAGE_LIST_FAILURE]: listFailure,

  [Types.SET_SETTINGS]: setObject,

  [Types.ORDER_TAGS_REQUEST]: createRequest,
  [Types.UPDATE_ORDER_TAGS]: updateRequest,

  [Types.CONNECT_APPLE_CALENDAR_REQUEST]: createRequest,
  [Types.DISCONNECT_APPLE_CALENDAR_REQUEST]: createRequest,

  [Types.DISCONNECT_HUBSPOT]: createRequest,

  [Types.TIMEZONE_LIST_REQUEST]: timezoneListRequest,
  [Types.TIMEZONE_LIST_SUCCESS]: timezoneListSuccess,
  [Types.TIMEZONE_LIST_FAILURE]: timezoneListFailure,
})
